import { defaultFilter, defaultRequestForm } from './majority-factory';

export type CoversageResponse = {
  id: number;
  code: string;
}

export type MajorityCoverage = {
  comment: string;
  coverageExtensionLimitDate: string;
  coverageExtensionReason: string;
  documents: number[];
  isCoverageLimitIndefinite: boolean;
}

export type MajorityExclusion = {
  comment: string;
  documents: number[];
  endDate: string;
  exclusionReasonCode: string;
}

export type MajorityRequest = {
  carrierId: number | null;
  competenceMonth: number | null;
  competenceYear: number | null;
  contractId: number | null;
  coverageExtensionReason: string | number | null;
  externalProtocol: string | null;
  financialGroupId: number | null;
  cpf: string | null;
  name: string | null;
  majorityStatus: MajorityStatus;
  monthsAdvance: number[];
  subContractId: number | null;
  page: number;
  size: number;
  sort: string;
}

export type Majority = {
  actionAt: string;
  actionComment: string;
  actionUser: string;
  benefitType: string;
  birthDate: string;
  carrierId: number;
  carrierName: string;
  competenceMonth: number;
  competenceYear: number;
  contractId: number;
  coverageExtensionLimitDate: string;
  coverageExtensionReason: string;
  createdAt: string;
  dependentContractedPlanId: number;
  dependentContractedName: string;
  exclusionReasonCode: string;
  externalProtocol: string;
  externalProtocolStatus: string | null;
  familyCode: number | null;
  familyCodeSeq: string | null;
  financialGroupId: number;
  financialGroupName: string;
  holderDocumentNumber: number;
  holderRegistrationPlate: string;
  holderRegistrationComplement: string;
  holderBeneficiaryCard: string;
  holderName: string;
  id: number;
  insuredAge: number;
  insuredDocumentNumber: number;
  insuredName: string;
  kinshipName: string;
  kinshipCode: string;
  kinshipId: number;
  majorityStatus: MajorityStatus;
  monthsAdvance: number;
  policy: string;
  planCode: string;
  registrationPlate: string;
  ruleAge: number;
  subContractId: number;
  subcontractNumber: number;
  updatedAt: string;
  isReprocessable: boolean;
}

export type Coverage = {
  id: number;
  code: string;
  description: string;
}

export type MajorityStatus = 'EXCLUSION' | 'COVERAGE' | 'PENDING' | 'EXTENDED' | 'EXCLUDED' | 'CANCELED' | null | string;
export interface OpenRequestModal {
  majorityStatus: MajorityStatus,
  beneficiary: Majority,
}

export type DefaultFormFields = {
  comment: string | null;
  documents: number[];
}

export interface RequestExclusionForm extends DefaultFormFields {
  exclusionReasonCode: string | null;
  endDate: Date | null | string;
}

export interface RequestCoverageForm extends DefaultFormFields {
  coverageExtensionLimitDate: Date | null | string,
  coverageExtensionReason: string | null,
  isCoverageLimitIndefinite: boolean,
}

export class MajorityModel {
  beneficiary: Majority | null;
  coverages: Coverage[];
  filter: MajorityRequest;
  loadingPage: boolean;
  majorities: Majority[];
  majorityStatus: MajorityStatus;
  majorityTab: 'majority' | 'reports';
  monthsAdvances: any[];
  pageMounted: boolean;
  requestForm: RequestCoverageForm | RequestExclusionForm | null | {};
  showExportConfirmModal: boolean;
  showExportRequestModal: boolean;
  showModal: boolean;
  totalPages: number | null;
  totalElements: number | null;
  protocols: number[];

  constructor() {
    this.beneficiary = null;
    this.coverages = [];
    this.filter = defaultFilter();
    this.loadingPage = false;
    this.majorities = [];
    this.majorityStatus = null;
    this.majorityTab = 'majority';
    this.monthsAdvances = [
      {id: 1, value: '1 mês'},
      {id: 2, value: '2 meses'},
      {id: 3, value: '3 meses'},
      {id: 4, value: '4 meses'},
      {id: 5, value: '5 meses'},
      {id: 6, value: '6 meses'},
      {id: 7, value: '7 meses'},
      {id: 8, value: '8 meses'},
      {id: 9, value: '9 meses'},
      {id: 10, value: '10 meses'},
      {id: 11, value: '11 meses'},
      {id: 12, value: '12 meses'},
    ],
    this.pageMounted = false;
    this.requestForm = defaultRequestForm();
    this.showExportConfirmModal = false;
    this.showExportRequestModal = false;
    this.showModal = false;
    this.totalPages = null;
    this.totalElements = null;
    this.protocols = [];
  }
}